import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12 13.05 6.75 18.3a.72.72 0 0 1-.525.225.72.72 0 0 1-.525-.225.72.72 0 0 1-.225-.525q0-.3.225-.525L10.95 12 5.7 6.75a.72.72 0 0 1-.225-.525q0-.3.225-.525a.72.72 0 0 1 .525-.225q.3 0 .525.225L12 10.95l5.25-5.25a.72.72 0 0 1 .525-.225q.3 0 .525.225a.72.72 0 0 1 .225.525.72.72 0 0 1-.225.525L13.05 12l5.25 5.25a.72.72 0 0 1 .225.525.72.72 0 0 1-.225.525.72.72 0 0 1-.525.225.72.72 0 0 1-.525-.225z" }, null, -1)
  ])))
}
export default { render: render }